var map = {
	"./de-DE": [
		"./static/locales/de-DE.json",
		"locale-de-DE"
	],
	"./de-DE.json": [
		"./static/locales/de-DE.json",
		"locale-de-DE"
	],
	"./en-PI": [
		"./static/locales/en-PI.json",
		"locale-en-PI"
	],
	"./en-PI.json": [
		"./static/locales/en-PI.json",
		"locale-en-PI"
	],
	"./en-US": [
		"./static/locales/en-US.json",
		"locale-en-US"
	],
	"./en-US.json": [
		"./static/locales/en-US.json",
		"locale-en-US"
	],
	"./es-ES": [
		"./static/locales/es-ES.json",
		"locale-es-ES"
	],
	"./es-ES.json": [
		"./static/locales/es-ES.json",
		"locale-es-ES"
	],
	"./fr-FR": [
		"./static/locales/fr-FR.json",
		"locale-fr-FR"
	],
	"./fr-FR.json": [
		"./static/locales/fr-FR.json",
		"locale-fr-FR"
	],
	"./sv-SE": [
		"./static/locales/sv-SE.json",
		"locale-sv-SE"
	],
	"./sv-SE.json": [
		"./static/locales/sv-SE.json",
		"locale-sv-SE"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./static/locales lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;